import axios from "../../config/axiosConfig";
import { CREATE_CREDIT_NOTE, GET_CREDIT_NOTES, CREDIT_NOTE_REQUEST, UPDATE_CREDIT_NOTE, DELETE_CREDIT_NOTE,
  CREDIT_NOTE_REQUEST_FAILURE, CREDIT_NOTE_REQUEST_SUCCESS, GET_CREDIT_NOTES_PAGE } from "../types";

export const getCreditNotesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Debit_Account_Id,Item_Id'
      };
      return axios.get("/credit-note/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CREDIT_NOTES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getCreditNotes = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/credit-note/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CREDIT_NOTES, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
    }
  };
};
export const getCreditNotesByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/credit-note/getAll", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getCreditNoteById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
    
      return axios.get(`/credit-note/get/${id}`).then((response) => {
        dispatch({ type: CREDIT_NOTE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
        throw error;  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createCreditNote = (creditNote) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const newCreditNote = {
        ...creditNote
      };
      return axios.post("/credit-note/add", newCreditNote,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        console.log('<<response data--', response)
        if (response.data) {
          dispatch({ type: CREATE_CREDIT_NOTE, payload: response.data });
        } else {
          dispatch({
            type: CREDIT_NOTE_REQUEST_FAILURE,
            error: "Credit Note create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error('<<E', error);
        dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
  console.error('<<E', error);
      dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateCreditNote = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      return axios.put("/credit-note/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_CREDIT_NOTE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: CREDIT_NOTE_REQUEST_FAILURE,
            error: "Credit Note update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteCreditNote = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/credit-note/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_CREDIT_NOTE, id: id });
          const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Debit_Account_Id', 'Invoice_No', 'Invoice_Date', 'Amount', 'Total_Amount', 'Item_Id', 'Ack_No'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { transaction: { creditNote: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getCreditNotesWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const generateEInvoiceCreditNote = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      
      return axios.get(`/credit-note/generate-e-invoice/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_CREDIT_NOTE,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.log('generate eway bill error',error);
        dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const cancelEInvoiceCreditNote = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      return axios.post(`/credit-note/cancel-e-invoice/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_CREDIT_NOTE,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteEInvoiceCreditNote = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/credit-note/delete-e-invoice-bills", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
    }
  };
};


export const sendMailCreditNote = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('creditNoteId', mailData.creditNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `credit_node_${mailData.creditNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/credit-note/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: CREDIT_NOTE_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: CREDIT_NOTE_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: CREDIT_NOTE_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappCreditNote = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('creditNoteId', whatsappData.creditNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `credit_node_${whatsappData.creditNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/credit-note/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: CREDIT_NOTE_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: CREDIT_NOTE_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: CREDIT_NOTE_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};